<template>
  <div class="tags-list clearfix">
    <div
      class="item-box"
      v-for="item of tags"
      :key="item.id"
    >
      <div :class="!!item.special && item.special == '1' ? 'tag-item special' : 'tag-item'">
        # {{item}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsList',
  props: {
    tags: Array
  }
}
</script>

<style lang="scss" scoped>
.tags-list {
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 20px 0 0;
  @include respond-to(desktop) {
    flex-wrap: wrap;
    justify-content: start;
  }
}
.tags-list .item-box {
  border: 1px solid #fff;
  border-radius: 15px;
  padding: 8px 10px;
  font-size: 1.2rem;
  margin: 0 5px;
  line-height: 100%;
  @include respond-to(desktop) {
    margin-bottom: 10px;
  }
}
.tags-list .tag-item {
  padding: 0;
  width: auto;
  width: 100%;
  height: 14px;
  line-height: 16px;
  white-space:nowrap;
  // float: left;
  // height: 26px;
  // line-height: 26px;
  // padding: 0 8px;
  // margin: 0 3px 3px 0;
  // border: 1px solid rgba(217, 217, 214, .5);
  // border-radius: 13px;
  // font-size: 12px;
  // font-weight: 500;
  // color: rgba(255, 255, 255, .5);
  // &.special {
  //   color: nth($pink, 1);
  //   border-color: nth($pink, 1);
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/TagsList.vue